import Vue from "vue";
import App from "./App";
import makeStore from "./store/store";
import { i18n, setLanguageAttributes } from "./i18n";
import PortalVue from "portal-vue";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import { Fragment } from "vue-fragment";
import VueFriendlyIframe from "vue-friendly-iframe";
import "../src/assets/fancybox/jquery.fancybox.min.css";
import LoadScript from "vue-plugin-load-script";
import "../src/styles/main.scss";
import "../src/styles/components/imageEditorGalleries.scss";
import Vuex from "vuex";
import VTooltip from "v-tooltip";

Vue.use(VueFriendlyIframe);
Vue.use(Fragment);
Vue.use(PortalVue);
Vue.use(VueSweetalert2, { scrollbarPadding: false });
Vue.use(LoadScript);
Vue.use(Vuex);
Vue.use(VTooltip, {
  defaultTemplate:
    '<div class="printqApp_tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="printqApp_tooltip-inner"></div></div>',
  defaultInnerSelector: ".printqApp_tooltip-inner, .printqApp_tooltip__inner",
  popover: {
    // Base class (change if conflicts with other libraries)
    defaultBaseClass: "printqApp_tooltip"
  }
});

Vue.config.productionTip = false;

const fancybox = require("./assets/fancybox/jquery.fancybox.min.js");

const requireComponent = require.context(
  // Look for files in the current directory
  "./components",
  // Do not look in subdirectories
  true
  // Only include "_base-" prefixed .vue files
  ///_base-[\w-]+\.vue$/
);

// For each matching file name...
requireComponent.keys().forEach(fileName => {
  // Get the component config
  const componentConfig = requireComponent(fileName);
  // Get the PascalCase version of the component name
  const componentName = fileName
    // Remove the "./_" from the beginning
    .replace(/^\.\/_/, "")
    // Remove the file extension from the end
    .replace(/\.\w+$/, "")
    // Split up kebabs
    .split("-")
    // Upper case
    .map(kebab => {
      var fName =
        kebab.lastIndexOf("/") != -1
          ? kebab.substring(kebab.lastIndexOf("/") + 1)
          : kebab;
      return (fName.charAt(0).toUpperCase() + fName.slice(1)).replace("./", "");
    })
    // Concatenated
    .join("");

  var newComponenent = componentConfig.default || componentConfig;
  var className =
    "matrix_" +
    (componentName.charAt(0).toLowerCase() + componentName.slice(1));
  newComponenent = {
    ...newComponenent,
    mixins: [
      {
        computed: {
          getClassName() {
            return className;
          },
          getClassNameContainer() {
            return className + "Container";
          },
          getClassNameItem() {
            return className + "Item";
          },
          getContainerType: function () {
            // for containers we might decide to not show the outer div if we might also include elements from other componenets
            if (this.hideContainer) {
              return "fragment";
            } else {
              return "div";
            }
          },
          shouldRenderConfig: function () {
            return this.$store.getters.getShouldRenderComponent(componentName);
          }
        }
      }
    ]
  };

  // Globally register the component
  Vue.component("app" + componentName, newComponenent);
});

// register fragment to be for all application
Vue.component("fragment", Fragment);

class PrintqMatrixApp {
  vueInstance = null;
  init(args) {
    if (args.config && args.config.configLanguage) {
      // do nothing now
    } else if (args.language) {
      setLanguageAttributes(args.language);
    }
    var selector = "#printq_app";
    if (args.selector) {
      selector = args.selector;
    }

    if (args.jsAppRoot) {
      __webpack_public_path__ = args.jsAppRoot;
    }

    var portalElements = this.registerPortalComponents();
    if (
      args.beforeInitCallback &&
      typeof args.beforeInitCallback == "function"
    ) {
      args.beforeInitCallback();
    }
    this.vueInstance = new Vue({
      store: makeStore(),
      i18n,
      render: h =>
        h(App, {
          props: {
            ...args,
            portalElements,
            selector: selector.replace("#", "")
          }
        })
    });

    this.vueInstance.$store.dispatch("setVueInstance", this.vueInstance);
    return this.vueInstance.$mount(selector);
  }

  getStore() {
    return this.vueInstance.$store;
  }
  updateCustomer(customer, isLogin) {
    this.vueInstance.$store.dispatch("setCustomer", customer);
    this.vueInstance.$store.dispatch("setIsLogin", isLogin | 0);
  }

  filesConnected() {
    this.vueInstance.$store.dispatch(
      "setDisableDeleteUploadAfterConnect",
      true
    );
  }
  isValid() {
    return this.vueInstance.$store.getters.getIsValidForm(null);
  }

  registerPortalComponents() {
    var elements = document.getElementsByClassName("printq_portal");
    var portalElements = [];
    for (var el of elements) {
      if (el.getAttribute("data-portal") && el.getAttribute("id")) {
        var portal = JSON.parse(el.getAttribute("data-portal"));
        var portalId = el.getAttribute("id");
        var portalComponentname =
          "appPrintqPortal" + portal.component + "_" + portalId;
        this.registerComponent(
          portalId,
          "app" + portal.component,
          portalComponentname
        );

        portalElements.push(portalComponentname);
      }
    }

    return portalElements;
  }

  registerComponent(id, type, name) {
    Vue.component(name, {
      render: function (createElement) {
        return createElement(
          "MountingPortal",
          {
            attrs: {
              mountTo: "#" + id
            }
          },
          [createElement(type)]
        );
      }
    });
  }
}

window.PrintqMatrix = PrintqMatrixApp;
